import React from 'react'
import { BroadSignAcceptanceStatus } from '../../../../api/broadSign/models/broad-sign-creation-acceptance.model'

// the icons are drawn on boxes of their own, the viewBox keeps the drawing while they all render
// at one size
const ICON_SIZE = 22

const AcceptanceStatusIcon: React.FC<{ status: string }> = ({ status }) => {
  switch (status) {
    case BroadSignAcceptanceStatus.PENDING:
      return (
        <svg
          width={ICON_SIZE}
          height={ICON_SIZE}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M11.6667 0C18.1102 0 23.3333 5.22317 23.3333 11.6667C23.3333 18.1102 18.1102 23.3333 11.6667 23.3333C5.22317 23.3333 0 18.1102 0 11.6667C0 5.22317 5.22317 0 11.6667 0ZM11.6667 4.66667C11.3572 4.66667 11.0605 4.78958 10.8417 5.00838C10.6229 5.22717 10.5 5.52391 10.5 5.83333V11.6667C10.5001 11.9761 10.623 12.2728 10.8418 12.4915L14.3418 15.9915C14.5619 16.204 14.8566 16.3216 15.1625 16.319C15.4684 16.3163 15.761 16.1936 15.9773 15.9773C16.1936 15.761 16.3163 15.4684 16.319 15.1625C16.3216 14.8566 16.204 14.5619 15.9915 14.3418L12.8333 11.1837V5.83333C12.8333 5.52391 12.7104 5.22717 12.4916 5.00838C12.2728 4.78958 11.9761 4.66667 11.6667 4.66667Z'
            fill='#C9CC29'
          />
        </svg>
      )
    case BroadSignAcceptanceStatus.ACCEPTED:
      return (
        <svg
          width={ICON_SIZE}
          height={ICON_SIZE}
          viewBox='0 0 30 30'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15 26.25C16.4774 26.25 17.9403 25.959 19.3052 25.3936C20.6701 24.8283 21.9103 23.9996 22.955 22.955C23.9996 21.9103 24.8283 20.6701 25.3936 19.3052C25.959 17.9403 26.25 16.4774 26.25 15C26.25 13.5226 25.959 12.0597 25.3936 10.6948C24.8283 9.3299 23.9996 8.08971 22.955 7.04505C21.9103 6.00039 20.6701 5.17172 19.3052 4.60636C17.9403 4.04099 16.4774 3.75 15 3.75C12.0163 3.75 9.15483 4.93526 7.04505 7.04505C4.93526 9.15483 3.75 12.0163 3.75 15C3.75 17.9837 4.93526 20.8452 7.04505 22.955C9.15483 25.0647 12.0163 26.25 15 26.25ZM14.71 19.55L20.96 12.05L19.04 10.45L13.665 16.8988L10.8837 14.1163L9.11625 15.8837L12.8663 19.6337L13.8338 20.6013L14.71 19.55Z'
            fill='#2ECC29'
          />
        </svg>
      )
    case BroadSignAcceptanceStatus.REJECTED:
      return (
        <svg
          width={ICON_SIZE}
          height={ICON_SIZE}
          viewBox='0 0 25 25'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.0833 0C18.7558 0 24.1667 5.41088 24.1667 12.0833C24.1667 18.7558 18.7558 24.1667 12.0833 24.1667C5.41088 24.1667 0 18.7558 0 12.0833C0 5.41088 5.41088 0 12.0833 0ZM14.8541 7.604L12.0833 10.3748L9.31262 7.60412L7.60406 9.31268L10.3748 12.0833L7.60406 14.8541L9.31262 16.5626L12.0833 13.7919L14.8541 16.5626L16.5626 14.8541L13.7919 12.0833L16.5626 9.31262L14.8541 7.604Z'
            fill='#DC143C'
          />
        </svg>
      )
    default:
      return null
  }
}

export default AcceptanceStatusIcon
